<template>
	<div class="special special-voucher desktop-center">
		<i class="sk-icon-ticket-alt-solid special-icon" alt="Voucher"></i>
		<div class="voucher-block" v-if="voucherCode">
			<h3 class="special-subtitle">Voucher {{ voucherCode }} applied!</h3>
		</div>
		<div class="voucher-block" v-else>
			<h3 class="special-subtitle">
				Have a voucher?
				<button @click="couponClicked">Click here</button>
			</h3>
		</div>
	</div>
</template>

<style scoped>
.special {
	border-radius: 8px;
	max-width: 100%;
	margin: 0 auto 10px auto;
	min-height: 60px;
	max-height: 60px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding: 8px;
	background: linear-gradient(89.61deg, #ff7000 0.1%, #ff9948 99.96%);
}

.special-voucher {
	background: linear-gradient(90deg, #2f4858 0%, #2e3c49 100%);
}

.special-title {
	color: #fff;
	font-weight: 700;
	font-size: 16px;
	margin-bottom: 3px;
}

.special-subtitle {
	color: #fff;
	font-size: 14px;
	margin-bottom: 2px;
}

.special-icon {
	width: 40px;
	margin-right: 16px;
	margin-left: 20px;
	color: var(--gR-white);
	font-size: 32px;
}

.special-voucher button {
	background: none;
	color: #ffffff;
	font-weight: bold;
}

@media (max-width: 1000px) {
	.special {
		margin: 0 20px 20px 20px !important;
	}
}

@media (min-width: 1000px) {
	.special {
		margin-bottom: 25px !important;
	}
}
</style>

<script>
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"

export default {
	name: "CheckoutVoucherCta",
	computed: {
		voucherCode() {
			if (
				this.$store.state.coupon.id > 0 &&
				this.$store.state.coupon.couponType == 2
			) {
				return this.$store.state.coupon.code
			}
			return null
		}
	},
	methods: {
		couponClicked() {
			if (this.$store.state.coupon.code) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Remove Voucher Clicked",
					data: {
						code: this.$store.state.coupon.code
					}
				})
				this.$store.dispatch("removeCoupon")
			} else {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Add Voucher Clicked"
				})
				eventBus.emit(EventBusEvents.OPEN_COUPON_MODAL)
			}
		}
	}
}
</script>